import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicNav from '../components/public/PublicNav';
import PublicFooter from '../components/public/PublicFooter';

/**
 * Marketing/public surface layout. Modeled after chatbot.travelminds.com:
 * top nav with logo + nav links + Sign In CTA, full-bleed content, slim
 * footer with secondary links. Auth pages (login/signup/reset/etc.) use
 * AuthLayout directly and don't wrap with this layout — they're full-bleed.
 */
const pageMap: Record<string, 'home' | 'pricing' | 'faq' | 'help' | 'login' | 'signup' | 'demo'> = {
  '/': 'home',
  '/pricing': 'pricing',
  '/faq': 'faq',
  '/help': 'help',
  '/login': 'login',
  '/signup': 'signup',
  '/demo': 'demo',
};

const AUTH_PATHS = new Set([
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password',
  '/accept-invite',
]);

const PublicLayout: React.FC = () => {
  const location = useLocation();
  const current = pageMap[location.pathname];
  const isAuthPage = AUTH_PATHS.has(location.pathname);

  // Auth pages render their own full-bleed AuthLayout — skip the nav/footer chrome.
  if (isAuthPage) {
    return <Outlet />;
  }

  return (
    <div className="public-surface min-h-screen flex flex-col bg-white">
      <PublicNav current={current} />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
